<form class="layout-form" [formGroup]="taxForm" (ngSubmit)="onSubmit()">
  <div class="component-content">
    <div class="form-header">
      <p>Dados fiscais</p>
      <span> Preencha suas informações fiscais </span>
    </div>
    <div class="scroll-display">
      <div class="form-select-content">
        <div class="form-customer-data" #errorDiv>
          <!-- <app-select  [attr.data-testid]="'condition-iibb'" 
                        [labelText]="'Seleccione el tipo de persona'" [placeholder]="'Seleccionar'" [required]="true" 
                        formControlName="typePerson" [submitted]="submitted" [options]="personOption">
                    </app-select> -->
          <mat-radio-group aria-label="Select an option" formControlName="typePerson">
            <mat-radio-button class="radio-button" *ngFor="let person of personOption" [value]="person.value">{{
              person.text
            }}</mat-radio-button>
            <div *ngIf="submitted && !this.taxForm.controls['typePerson'].valid">
              <label class="warning-label">Debes elegir RUC o CI</label>
            </div>
          </mat-radio-group>
        </div>
        <div *ngIf="this.taxForm.controls['typePerson'].value == 'F'">
          <app-text-input
            [labelText]="'CPF'"
            [type]="'text'"
            [min]="11"
            [max]="11"
            [required]="true"
            formControlName="cpf"
            [submitted]="submitted"
            [placeholder]="'0000000'"
            ddata-testid="ci-input"
          >
          </app-text-input>
          <label class="warning-label" *ngIf="isDuplicated">
            {{ warningCuitText }}
          </label>
          <!-- <div class="form-customer-data">
                        <app-file-upload-component [labelText]="'Frente de CI'" [required]="true" [submitted]="submitted" 
                        [oneFile]="true" [documentId]="21" [isImg]="true" [ocrValidation]="false" [extensions]="['.png', '.jpeg', '.jpg']" 
                        formControlName="fileBackCi"  [maxSizeFile]="10" [id]="'fileBackCiId'" data-testid="ci-back-file">
                        </app-file-upload-component>
                        <app-file-upload-component [labelText]="'Dorso de CI'" [required]="true" [submitted]="submitted" 
                            [oneFile]="true" [documentId]="22" [isImg]="true" [ocrValidation]="true" [extensions]="['.png', '.jpeg', '.jpg']" 
                            formControlName="fileFrontCi"  [maxSizeFile]="10" [id]="'fileFrontCiId'" data-testid="ci-back-file">
                        </app-file-upload-component>
                        <div  *ngIf="ocrError">
                            <label class="warning-label" >No fue posible validar la CI. Por favor, adjunte nuevamente la imagen del dorso</label>
                        </div>
                    </div> -->
          <div class="form-customer-data">
            <app-text-input
              [labelText]="'Nome'"
              [type]="'text'"
              [required]="true"
              formControlName="name"
              [submitted]="submitted"
              data-testid="name-input"
            >
            </app-text-input>
            <app-text-input
              [labelText]="'Sobrenome'"
              [type]="'text'"
              [required]="true"
              formControlName="surname"
              [submitted]="submitted"
              data-testid="surname-input"
            >
            </app-text-input>
            <div class="component-input">
              <app-date-picker
                [maxDate]="maxDate"
                [formControlName]="'dateOfBirth'"
                [required]="true"
                [labelText]="'Data de Nascimento'"
              ></app-date-picker>
              <label
                class="warning-label"
                *ngIf="
                  this.taxForm.controls['dateOfBirth'].value &&
                  !Is18YearsOld(this.taxForm.controls['dateOfBirth'].value)
                "
              >
                {{ warningBirthdayText }}
              </label>
            </div>
          </div>
        </div>

        <div *ngIf="this.taxForm.controls['typePerson'].value == 'J'">
          <div class="form-customer-data">
            <app-text-input
              [labelText]="'CNPJ'"
              [type]="'text'"
              [required]="true"
              [min]="14"
              [max]="14"
              formControlName="cnpj"
              [submitted]="submitted"
              [placeholder]="'0000000000-0'"
              data-testid="ruc-input"
            >
            </app-text-input>
            <label class="warning-label" *ngIf="isDuplicated">
              {{ warningCuitText }}
            </label>
          </div>
          <div class="form-customer-data">
            <app-text-input
              [type]="'number'"
              [disabled]="this.taxForm.controls['stateRegisterISENTO'].value"
              [labelText]="'Numero de Inscricao estadual'"
              [required]="stateRegisterIsRequired"
              formControlName="stateRegisterNumber"
              [submitted]="submitted"
              [placeholder]="taxForm.controls['stateRegisterISENTO'].value ? 'ISENTO' : '0000000000'"
              data-testid="state-register-number-input"
            >
            </app-text-input>
            <mat-checkbox (change)="changeIsento($event)" formControlName="stateRegisterISENTO">ISENTO</mat-checkbox>
          </div>
          <div class="form-customer-data">
            <app-text-input
              [labelText]="'Razão social'"
              [type]="'text'"
              [required]="true"
              [max]="100"
              formControlName="socialReason"
              [submitted]="submitted"
              data-testid="social-reason"
            >
            </app-text-input>
          </div>
          <!-- <app-text-input [labelText]="'Cedula de identidad'" [type]="'number'" [min]="6"   [required]="true"
                    formControlName="ci" [submitted]="submitted" [placeholder]="'0000000'" ddata-testid="ci-input">
                    </app-text-input> -->
          <div class="form-customer-data">
            <app-text-input
              [labelText]="'Nome'"
              [type]="'text'"
              [required]="true"
              formControlName="name"
              [submitted]="submitted"
              data-testid="name-input"
            >
            </app-text-input>
          </div>
          <div class="form-customer-data">
            <app-text-input
              [labelText]="'Sobrenome'"
              [type]="'text'"
              [required]="true"
              formControlName="surname"
              [submitted]="submitted"
              data-testid="surname-input"
            >
            </app-text-input>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="form-navigation">
    <app-navigation [currentStep]="3" [countSteppers]="5"></app-navigation>
  </div>
  <div class="button-container">
    <button mat-raised-button class="back-button" type="button" (click)="back()">Antigo</button>
    <button mat-raised-button class="next-button next-button__60" type="submit">Seguindo</button>
  </div>
</form>
